import { Fragment, useCallback, useEffect, useState } from "react";
import { addIssue, getIssueDetail, updateIssue } from "../../services/ api_services";
import { ToastTypes } from "../../context/ToastProvider";
import { isEmpty, isEqual, isObject } from "lodash";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from "@headlessui/react";
import { SlCheck } from "react-icons/sl";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/24/solid";
import ReactQuill from "react-quill";
import useAuth from "../../hooks/useAuth";
import useLoading from "../../hooks/useLoading";
import axios from "axios";
import useToast from "../../hooks/useToast";
// import { formatDate } from "../../core/Util";

const AddNotice = () => {
    const { auth } = useAuth();
    const { showToast } = useToast();
    const { loading, setLoading } = useLoading();
    const navigate = useNavigate();

    const getstringDate = (date) => {
        return date.toISOString().slice(0, 10);
    };

    const [today, setDate] = useState(getstringDate(new Date()));

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    const initialRequest = {
        seq: null,
        stateType: "", //진행상태
        issueType: "", //이슈타입
        priorityType: "", //긴급도
        gubunType: "", //구분
        subject: "", //제목
        re_user_seq: "", //등록자 seq
        in_name: "", //검토자
        reg_date: "", //등록일
        end_date: "", //완료일
        content: "", //이슈내용
        re_content: "", //검토결과
        // useYn: "",
    };

    const sub = {
        title: "",
        button: "",
    };

    const stateType = [
        { name: "등록", value: "1" },
        { name: "검토중", value: "2" },
        { name: "검토완료", value: "3" },
        { name: "보류", value: "4" },
        { name: "완료", value: "5" },
        { name: "선택하세요", value: "n" },
    ];
    const issueType = [
        { name: "선택하세요", value: "n" },
        { name: "오류", value: "1" },
        { name: "개선요청", value: "2" },
        { name: "문의", value: "3" },
    ];
    const gubunType = [
        { name: "선택하세요", value: "n" },
        { name: "관리자 페이지", value: "1" },
        { name: "홈페이지", value: "2" },
        { name: "모바일", value: "3" },
    ];
    const priorityType = [
        { name: "선택하세요", value: "n" },
        { name: "높음(긴급)", value: "1" },
        { name: "보통", value: "2" },
        { name: "낮음", value: "3" },
    ];

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }, { color: [] }, { background: [] }], // dropdown with defaults from theme
            // ["clean"],
        ],
    };

    const [request, setRequest] = useState(initialRequest);
    const [Submit, setSubmit] = useState(sub);
    const [searchParams, setSearchParams] = useSearchParams();
    const [adminName, setAdminName] = useState("");
    const [selectedState, setSelectedState] = useState(stateType[0]);
    const [selectedIssue, setSelectedIssue] = useState(issueType[0]);
    const [selectedGubun, setSelectedGubun] = useState(gubunType[0]);
    const [selectedPrior, setSelectedPrior] = useState(priorityType[0]);

    useEffect(() => {
        issueDetail();
        divStr();
    }, []);

    useEffect(() => {
        console.log("🚀 ~ AddIssue ~ request:", request);
    }, [request]);

    const ParamsSeq = searchParams.get("id");
    const issueDetail = useCallback(async () => {
        console.log("🚀 ~ Called issue detail ==> ");
        try {
            const response = await getIssueDetail(ParamsSeq);
            const issuetype = response.data.issue.issueType;
            const statetype = response.data.issue.stateType;
            const gubuntype = response.data.issue.gubunType;
            const prioritytype = response.data.issue.priorityType;
            console.log("🚀 ~ noticeDetail ~ response:", response);
            if (response && response.status === 200 && isObject(response.data)) {
                response.data.issue.reg_date = formatDate(response.data.issue.reg_date);
                // response.data.issue.end_date = formatDate(response.data.issue.end_date);
                const dateTimeString = formatDate(response.data.issue.end_date);
                if (dateTimeString) {
                    const dateString = dateTimeString.split(" ")[0];
                    response.data.issue.end_date = dateString;
                }

                setRequest(response.data.issue);
                setAdminName(response.data.admin_nm);
                if (issuetype === null) {
                    setSelectedIssue(issueType.find((item) => item.value === "n"));
                } else {
                    setSelectedIssue(issueType.find((item) => item.value === issuetype));
                }
                if (statetype === null) {
                    setSelectedState(stateType.find((item) => item.value === "n"));
                } else {
                    setSelectedState(stateType.find((item) => item.value === statetype));
                }
                if (gubuntype === null) {
                    setSelectedGubun(gubunType.find((item) => item.value === "n"));
                } else {
                    setSelectedGubun(gubunType.find((item) => item.value === gubuntype));
                }
                if (prioritytype === null) {
                    setSelectedPrior(priorityType.find((item) => item.value === "n"));
                } else {
                    setSelectedPrior(priorityType.find((item) => item.value === prioritytype));
                }
            } else {
                console.log("INITIAL ==> ");
                setRequest(initialRequest);
            }
        } catch (e) {
            console.log("🚀 ~  ~ response:");
        }
    }, [ParamsSeq]);
    // console.log("seq " + ParamsSeq);

    const updateAPI = async () => {
        setLoading(true);
        try {
            if (request.issueType == null || request.issueType == "" || request.issueType == "n") {
                showToast(ToastTypes.WARNING, "이슈타입을 선택해주세요.", "필수 선택값 입니다.");
                setLoading(false);
            } else if (request.stateType == null || request.stateType == "" || request.stateType == "n") {
                showToast(ToastTypes.WARNING, "진행상태를 선택해주세요.", "필수 선택값 입니다.");
                setLoading(false);
            } else if (request.priorityType == null || request.priorityType == "" || request.priorityType == "n") {
                showToast(ToastTypes.WARNING, "긴급도를 선택해주세요.", "필수 선택값 입니다.");
                setLoading(false);
            } else if (request.gubunType == null || request.gubunType == "" || request.gubunType == "n") {
                showToast(ToastTypes.WARNING, "구분을 선택해주세요.", "필수 선택값 입니다.");
                setLoading(false);
            } else if (request.subject == null || request.subject == "" || request.subject == "n" || request.subject.length <= 1) {
                showToast(ToastTypes.WARNING, "두 글자 이상 제목을 입력해주세요.", "필수 입력값 입니다.");
                setLoading(false);
            } else if (
                request.content == null ||
                request.content == "" ||
                request.content == "<p><br></p>" ||
                request.content.length <= 1
            ) {
                showToast(ToastTypes.WARNING, "이슈 내용을 입력해주세요.", "필수 입력값 입니다.");
                setLoading(false);
            } else if (request.re_content != null && request.re_content != "") {
                if (request.in_name == null || request.in_name == "" || request.in_name == "null") {
                    showToast(ToastTypes.WARNING, "검토자를 입력해주세요.", "검토결과 입력시 필수 입력값 입니다.");
                    setLoading(false);
                } else {
                    console.log("🚀 ~ updateAPI ~ request:", request);
                    const response = await updateIssue(request);
                    console.log("🚀 ~ updateAPI ~ response:", response);

                    setLoading(false);
                    if (response && response.status === 200 && !isEmpty(response.data)) {
                        showToast(ToastTypes.SUCCESS, "성공", "이슈 수정이 완료되었습니다.");
                    } else {
                        showToast(ToastTypes.ERROR, "오류", "이슈 수정 중 오류가 발생하였습니다.");
                    }
                }
            } else {
                console.log("🚀 ~ updateAPI ~ request:", request);
                const response = await updateIssue(request);
                console.log("🚀 ~ updateAPI ~ response:", response);

                setLoading(false);
                if (response && response.status === 200 && !isEmpty(response.data)) {
                    showToast(ToastTypes.SUCCESS, "성공", "이슈 수정이 완료되었습니다.");
                } else {
                    showToast(ToastTypes.ERROR, "오류", "이슈 수정 중 오류가 발생하였습니다.");
                }
            }
        } catch (e) {
            setLoading(false);
            if (axios.isCancel(e)) {
            } else {
                console.error("Error update issue: ", e);
            }
        }
    };

    const addAPI = async () => {
        setLoading(true);
        console.log("🚀 ~ addAPI ~ request:", request);

        try {
            let requestTmp = request;
            if (requestTmp.issueType == null || requestTmp.issueType == "" || requestTmp.issueType == "n") {
                showToast(ToastTypes.WARNING, "이슈타입을 선택해주세요.", "필수 선택값 입니다.");
                setLoading(false);
            } else if (requestTmp.priorityType == null || requestTmp.priorityType == "" || requestTmp.priorityType == "n") {
                showToast(ToastTypes.WARNING, "긴급도를 선택해주세요.", "필수 선택값 입니다.");
                setLoading(false);
            } else if (requestTmp.gubunType == null || requestTmp.gubunType == "" || requestTmp.gubunType == "n") {
                showToast(ToastTypes.WARNING, "구분을 선택해주세요.", "필수 선택값 입니다.");
                setLoading(false);
            } else if (
                requestTmp.subject == null ||
                requestTmp.subject == "" ||
                requestTmp.subject == "n" ||
                requestTmp.subject.length <= 1
            ) {
                showToast(ToastTypes.WARNING, "두 글자 이상 제목을 입력해주세요.", "필수 입력값 입니다.");
                setLoading(false);
            } else if (requestTmp.content == null || requestTmp.content == "" || requestTmp.content == "<p><br></p>") {
                showToast(ToastTypes.WARNING, "이슈 내용을 입력해주세요.", "필수 입력값 입니다.");
                setLoading(false);
            } else {
                requestTmp.re_user_seq = auth.admin_seq;
                requestTmp.stateType = "1";
                // requestTmp.useYn = "Y";
                console.log("🚀 ~ addAPI ~ requestTmp:", requestTmp);
                const response = await addIssue(requestTmp);

                setLoading(false);
                console.log("🚀 ~ addAPI ~ response:", response);
                if (response && response.status === 200 && !isEmpty(response.data)) {
                    showToast(ToastTypes.SUCCESS, "성공", "이슈 등록이 완료되었습니다.");
                    navigate("/ad/issue");
                } else {
                    showToast(ToastTypes.ERROR, "오류", "이슈 등록 중 오류가 발생하였습니다.");
                }
            }
        } catch (e) {
            setLoading(false);
            if (axios.isCancel(e)) {
            } else {
                console.error("Error add issue: ", e);
            }
        }
    };

    const handleOnClickButton = async () => {
        console.log("REQUEST ==> ", request);
        if (request.seq) {
            await updateAPI();
        } else {
            await addAPI();
        }
    };

    // const checkYn = async () => {   //사용여부 확인
    //     try {
    //         if (request.useYn === "Y") {    //버튼 누르면 'Y'->'N'으로 바뀜
    //             setRequest((preVal) => {
    //                 return {
    //                     ...preVal,
    //                     useYn: "N",
    //                 };
    //             });
    //         } else {
    //             setRequest((preVal) => {
    //                 return {
    //                     ...preVal,
    //                     useYn: "Y",
    //                 };
    //             });
    //         }
    //     } catch (e) {
    //         console.log("🚀 ~  ~ response:");
    //     }
    // };

    const divStr = async () => {
        if (ParamsSeq == null) {
            const save = {
                title: "등록",
                button: "등록",
            };
            setSubmit(save);
        } else {
            const update = {
                title: "상세",
                button: "수정",
            };
            setSubmit(update);
        }
    };

    // 날짜 뒤에 지워줌
    function formatDate(dateString) {
        // console.log("🚀 ~ formatDate ~ dateString:", dateString);
        if (!dateString) return;
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        };
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", options).format(date).replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$3-$1-$2");
    }

    //'진행상태' selectbox
    const statedropdownType = () => {
        return (
            <Listbox
                value={selectedState}
                onChange={(e) => {
                    // console.log("🚀 ~ UserInfo ~ e.value:", e.value);
                    setRequest((preVal) => {
                        return {
                            ...preVal,
                            stateType: e.value,
                        };
                    });
                    setSelectedState(stateType.find((item) => item.value === e.value));
                }}
            >
                <div className="lg:w-36 sm:w-5/6 relative">
                    {ParamsSeq ? (
                        <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                            <span className="block truncate">{selectedState.name}</span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </span>
                        </ListboxButton>
                    ) : (
                        <ListboxButton className="relative w-full cursor-default rounded-md bg-gray-100 py-1.5 pl-3 pr-10 text-left text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 sm:text-sm sm:leading-6">
                            <span className="block truncate">{selectedState.name}</span>
                        </ListboxButton>
                    )}

                    {ParamsSeq ? (
                        <ListboxOptions
                            transition
                            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                        >
                            {stateType.map((type, index) => (
                                <ListboxOption
                                    key={index}
                                    className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:font-bold data-[focus]:text-white"
                                    value={type}
                                >
                                    <>
                                        <span className="block truncate font-normal group-data-[selected]:font-semibold">{type.name}</span>
                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                            <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                        </span>
                                        {/* <span className={classNames(selected ? "font-semibold" : "font-normal", "block truncate")}>
                                                    {type.name}
                                                </span> */}

                                        {/* {selected ? (
                                                    <span
                                                        className={classNames(
                                                            active ? "text-white" : "text-blue-600",
                                                            "absolute inset-y-0 right-0 flex items-center pr-4"
                                                        )}
                                                    >
                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                ) : null} */}
                                    </>
                                </ListboxOption>
                            ))}
                        </ListboxOptions>
                    ) : null}
                </div>
            </Listbox>
        );
    };
    //'이슈타입' selectbox
    const issuedropdownType = () => {
        return (
            <Listbox
                value={selectedIssue}
                onChange={(e) => {
                    console.log("🚀 ~ UserInfo ~ e.value:", e.value);
                    setRequest((preVal) => {
                        return {
                            ...preVal,
                            issueType: e.value,
                        };
                    });
                    const selectedIssue = issueType.find((item) => item.value === e.value);
                    console.log("🚀 ~ issuedropdownType ~ selectedIssue:", selectedIssue);
                    setSelectedIssue(selectedIssue);
                }}
            >
                <div className="relative mt-2">
                    <div className="lg:w-36 sm:w-5/6">
                        <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                            <span className="block truncate">{selectedIssue.name}</span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                            </span>
                        </ListboxButton>
                    </div>

                    <ListboxOptions
                        transition
                        className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                    >
                        {issueType.map((option) => (
                            <ListboxOption
                                key={option.value}
                                value={option}
                                className="group relative cursor-default select-none py-2 pl-3 pr-4 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:text-white"
                            >
                                <span
                                    className={classNames(
                                        isEqual(option, selectedIssue) ? "font-semibold" : "",
                                        "block truncate font-normal group-data-[focus]:font-semibold"
                                    )}
                                >
                                    {option.name}
                                </span>

                                {isEqual(option, selectedIssue) && (
                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600  group-data-[focus]:text-white ">
                                        <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                    </span>
                                )}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </div>
            </Listbox>
        );
    };
    //'구분' selectbox
    const gubundropdownType = () => {
        return (
            <Listbox
                value={selectedGubun}
                onChange={(e) => {
                    // console.log("🚀 ~ UserInfo ~ e.value:", e.value);
                    setRequest((preVal) => {
                        return {
                            ...preVal,
                            gubunType: e.value,
                        };
                    });
                    setSelectedGubun(gubunType.find((item) => item.value === e.value));
                }}
            >
                <div className="lg:w-36 sm:w-5/6 relative mt-2">
                    <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                        <span className="block truncate">{selectedGubun.name}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                    </ListboxButton>
                    <ListboxOptions
                        transition
                        className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                        {gubunType.map((type, index) => (
                            <ListboxOption
                                key={index}
                                value={type}
                                className="group relative cursor-default select-none py-2 pl-3 pr-4 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:text-white"
                            >
                                <span
                                    className={classNames(
                                        isEqual(type, selectedGubun) ? "font-semibold" : "",
                                        "block truncate font-normal group-data-[focus]:font-semibold"
                                    )}
                                >
                                    {type.name}
                                </span>

                                {isEqual(type, selectedGubun) && (
                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600  group-data-[focus]:text-white ">
                                        <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                    </span>
                                )}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </div>
            </Listbox>
        );
    };
    //'긴급도' selectbox
    const prioritydropdownType = () => {
        return (
            <Listbox
                value={selectedPrior}
                onChange={(e) => {
                    // console.log("🚀 ~ UserInfo ~ e.value:", e.value);
                    setRequest((preVal) => {
                        return {
                            ...preVal,
                            priorityType: e.value,
                        };
                    });
                    setSelectedPrior(priorityType.find((item) => item.value === e.value));
                }}
            >
                <div className="lg:w-36 sm:w-5/6 relative">
                    <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                        <span className="block truncate">{selectedPrior.name}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                    </ListboxButton>

                    <ListboxOptions
                        transition
                        className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                        {priorityType.map((type, index) => (
                            <ListboxOption
                                key={index}
                                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:font-bold data-[focus]:text-white"
                                value={type}
                            >
                                <span
                                    className={classNames(
                                        isEqual(type, selectedPrior) ? "font-semibold" : "",
                                        "block truncate font-normal group-data-[focus]:font-semibold"
                                    )}
                                >
                                    {type.name}
                                </span>
                                {isEqual(type, selectedPrior) && (
                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600  group-data-[focus]:text-white ">
                                        <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                    </span>
                                )}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </div>
            </Listbox>
        );
    };

    return (
        <div>
            <span className="flex text-center justify-center align-middle text-nowrap text-gray-800 font-semibold text-2xl">
                이슈 {Submit.title}
            </span>

            <div className="flex justify-end mt-5 pr-3">
                {/* {auth.admin_seq === request.regUserSeq ? ( */}
                {ParamsSeq ? null : (
                    // <div className="flex items-center">
                    //     <input type="checkbox"
                    //         className="h-4 w-4 mr-1 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    //         checked={request.useYn === "Y"}
                    //         onChange={checkYn}
                    //     />
                    //     <label>사용 [체크 해제 시 목록에 표시되지 않습니다]</label>
                    // </div>
                    <div className="flex">
                        <span className="text-red-600">*&nbsp;</span> <span className="">모든 입력란은 필수입니다.</span>
                    </div>
                )}
            </div>

            {/* 선텍 영역 */}
            <div className="flex px-2 pb-2 justify-center items-center">
                <div className="w-full max-w-full rounded-1xl bg-gray-100 border-gray-300 border px-6 py-4 justify-between items-center">
                    <div className="lg:flex px-3 py-4 justify-center items-center">
                        <div className="lg:flex flex-wrap">
                            <div className="">
                                <div className="flex text-start text-sm text-gray-800 py-1">
                                    <div className="flex justify-end pr-3 w-24 items-center">
                                        진행상태<div className="text-red-600">*</div>
                                    </div>
                                    {statedropdownType()}
                                </div>
                                <div className="flex text-start text-sm text-gray-800 py-1">
                                    <div className="flex justify-end pr-3 w-24 items-center">
                                        이슈타입<div className="text-red-600">*</div>
                                    </div>
                                    {issuedropdownType()}
                                </div>
                            </div>
                            <div className="">
                                <div className="flex text-start text-sm text-gray-800 py-1">
                                    <div className="flex justify-end pr-3 w-24 items-center">
                                        긴급도<div className="text-red-600">*</div>
                                    </div>
                                    {prioritydropdownType()}
                                </div>
                                <div className="flex text-start text-sm text-gray-800 py-1">
                                    <div className="flex justify-end pr-3 w-24 items-center">
                                        구분<div className="text-red-600">*</div>
                                    </div>
                                    {gubundropdownType()}
                                </div>
                            </div>
                        </div>

                        <div className="lg:flex flex-wrap">
                            <div className="">
                                <div className="flex text-start text-sm text-gray-800 py-1">
                                    <div className="flex justify-end pr-3 w-24 items-center">
                                        제목<div className="text-red-600">*</div>
                                    </div>
                                    <input
                                        type="text"
                                        defaultValue={request.subject}
                                        className="lg:w-4/5 sm:w-5/6 relative rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                        onChange={(e) => {
                                            setRequest((preVal) => {
                                                return {
                                                    ...preVal,
                                                    subject: e.target.value,
                                                };
                                            });
                                        }}
                                    />
                                </div>
                                <div className="flex flex-wrap text-start text-sm text-gray-800">
                                    <div className="flex py-1">
                                        <div className="flex justify-end pr-3 w-24 items-center">등록자 </div>
                                        <input
                                            type="text"
                                            className="w-36 caret-transparent rounded-md border-0 px-3.5 py-2 bg-gray-100 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                            value={ParamsSeq ? adminName : auth.admin_name}
                                            readonly
                                        />
                                    </div>
                                    <div className="flex py-1">
                                        <div className="flex justify-end pr-3 w-24 items-center">등록일 </div>
                                        <input
                                            type="text"
                                            value={ParamsSeq ? request.reg_date : today}
                                            className="w-40 caret-transparent border bg-gray-100 border-gray-300 text-gray-500 focus:border-purple-500 text-sm rounded-lg"
                                            readonly
                                        />
                                    </div>
                                </div>
                            </div>

                            {!ParamsSeq ? null : (
                                <div className="">
                                    <div className="flex text-start text-sm text-gray-800 py-1">
                                        <div className="flex justify-end pr-3 w-24 items-center">검토자 </div>
                                        <input
                                            type="text"
                                            className="w-4/6 rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                            defaultValue={request.in_name}
                                            onChange={(e) => {
                                                setRequest((preVal) => {
                                                    return {
                                                        ...preVal,
                                                        in_name: e.target.value,
                                                    };
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="flex text-start text-sm text-gray-800 py-1">
                                        <div className="flex justify-end pr-3 w-24 items-center">완료일 </div>
                                        <input
                                            type="date"
                                            className="w-4/6 form-input border bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500 text-sm rounded-lg"
                                            value={request.end_date}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="lg:flex justify-between">
                {/* 버튼 영역 */}
                <div className="flex lg:justify-end sm:justify-center py-4 pr-2">
                    <div className="mr-3">
                        <button
                            type="button"
                            className="w-32 rounded-md inline-flex gap-x-1 items-center justify-center bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => handleOnClickButton()}
                        >
                            <SlCheck className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            {Submit.button}
                        </button>
                    </div>

                    <div>
                        <button
                            onClick={() => {
                                navigate("/ad/Issue");
                            }}
                            type="button"
                            className="lg:w-20 sm:w-32 rounded-md bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-100"
                        >
                            목록
                        </button>
                    </div>
                </div>

                {/* 내용입력 영역 */}
                <div className="px-2 pb-2 lg:w-4/6 lg:order-first sm:order-last items-center">
                    <div className="flex py-4 mb-8 justify-center">
                        <div className="flex justify-end pt-1 pr-3 w-28">
                            이슈 내용<div className="text-red-600">*</div>
                        </div>
                        <ReactQuill
                            className="rounded-md"
                            value={request.content}
                            style={{ width: "100%", height: "250px" }}
                            modules={modules}
                            onChange={(e) => {
                                setRequest((preVal) => {
                                    return {
                                        ...preVal,
                                        content: e,
                                    };
                                });
                            }}
                        />
                    </div>
                    {!ParamsSeq ? null : (
                        <div className="flex py-4 mb-8 justify-center">
                            <div className="flex justify-end pt-1 pr-3 w-28">검토 결과</div>
                            <textarea
                                className="border-gray-300"
                                defaultValue={request.re_content}
                                onChange={(e) => {
                                    setRequest((preVal) => {
                                        return {
                                            ...preVal,
                                            re_content: e.target.value,
                                        };
                                    });
                                }}
                                style={{ width: "100%", height: "200px" }}
                            ></textarea>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AddNotice;
